import dJSON from 'dirty-json';

const moduleSelector = '.horizontal-grid';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        const hasFullAnchor = query.classList.contains('full-anchor');

        if (hasFullAnchor) {
          // When full-anchor is present, make grid-item an anchor (if button_link exists) or div
          const hasButtonLink = item.button_link && item.button_link.trim() !== '';
          const gridItemTag = hasButtonLink ? 'a' : 'div';
          const gridItemAttrs = hasButtonLink ? `href="${item.button_link}"` : '';

          query.insertAdjacentHTML('beforeend', /* html */ `
            <${gridItemTag} ${gridItemAttrs} class="grid-item flex-custom">
              ${item.background ? `<img src="${item.background}" alt="${item.title}" />` : ''}
              <div class="content">
                ${item.title ? `<h2 class="title">${item.title}</h2>` : ''}
                ${item.text ? `<p class="text">${item.text}</p>` : ''}
                ${item.button_text ? `<button type="button" class="btn-custom primary">${item.button_text}</button>` : ''}
              </div>
            </${gridItemTag}>
          `);
        } else {
          // Default behavior - grid-item as div with anchor button
          query.insertAdjacentHTML('beforeend', /* html */ `
            <div class="grid-item flex-custom">
              ${item.background ? `<img src="${item.background}" alt="${item.title}" />` : ''}
              <div class="content">
                ${item.title ? `<h2 class="title">${item.title}</h2>` : ''}
                ${item.text ? `<p class="text">${item.text}</p>` : ''}
                ${item.button_text ? `<a href="${item.button_link}" class="btn-custom primary">${item.button_text}</a>` : ''}
              </div>
            </div>
          `);
        }
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Animation
 */
(() => {
  const target = document.querySelectorAll('.anim-custom .horizontal-grid .grid-item');
  const observer = new IntersectionObserver((e) => {
    e.forEach((item) => {
      if (item.isIntersecting) {
        item.target.classList.add('active');
      }
    });
  }, {
    threshold: 0.5,
  });

  target.forEach((item) => {
    observer.observe(item);
  });
})();
